import Vue from 'vue';

export const state = () => ({
  state: () => ({
    loading: false,
    data: null,
    current_step: null,
  }),
});

export const getters = {
  get(state) {
    return state.data;
  },

  id(state) {
    if (!state.data) {
      return false;
    }

    return state.data._id;
  },
};

export const mutations = {
  set(state, data) {
    state.loading = false;
    Vue.set(state, 'data', data);
  },

  setWizard(state, wizard) {
    state.data.loading = false;
    state.data.wizard = wizard;
  },

  setNotes(state, notes) {
    state.data.loading = false;
    state.data.notes = notes;
  },

  loading(state) {
    state.loading = true;
  },

  setCurrentStep(state, route) {
    Vue.set(state, 'current_step', route);
  },
};

export const actions = {
  get({ commit }, writtenId) {
    commit('loading');

    return this.$axios
      .get(`/v0/app/verbal-warning/${writtenId}`)
      .then((res) => {
        commit('set', res.data);

        return res.data;
      });
  },

  updateWizard({ commit, getters }, wizard) {
    commit('loading');

    return this.$axios
      .post(`/v0/app/verbal-warning/${getters.id}/update`, { wizard })
      .then((res) => {
        commit('setWizard', res.data.wizard);

        return res.data.wizard;
      });
  },
};
